/**
 * @file paddle pilot all group
 * @author wanzhongyun
 */

import React, { useEffect, useState } from 'react';
import { Modal, Radio, RadioChangeEvent, Pagination } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import AcademicSearch from './../../../academicEcology/components/academic-search/AcademicSearch';
import { IPilotGroup, IPilotGroupCityList } from './../../type';

import './style.less';

const PilotAllGroup: React.FC<IPilotGroup> = props => {

    const { title, cityGroup, schoolGroup } = props;


    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [radioValue, setRadioValue] = useState<string>();
    const [searchWord, setSearchWord] = useState<string>('');
    const [currentList, setCurrentList] = useState<IPilotGroupCityList[]>([]);
    const [page, setPage] = useState<number>(1);
    const [dataToal, setDataTotal] = useState<number>(0);

    const groupOptions = [
        { label: cityGroup.title, value: cityGroup.title },
        { label: schoolGroup.title, value: schoolGroup.title }
    ];


    // 下面的两个函数处理modal的筛选逻辑
    const handleRadioChange = (e: RadioChangeEvent) => {
        setRadioValue(e.target.value);
        const tempList = e.target.value === cityGroup.title ? cityGroup.list : schoolGroup.list;
        const resultList = tempList.filter(item => {
            return item.name.includes(searchWord) || item.desc.includes(searchWord) || !searchWord;
        });
        setDataTotal(resultList.length);
        setCurrentList(resultList);
        setPage(1);
    };

    const handleSearch = (e: any) => {
        // 针对数组的名字和头衔做一个filter操作，筛选数组项
        const tempCurrentList = radioValue === cityGroup.title ? cityGroup.list : schoolGroup.list;
        const filterList = tempCurrentList.filter(item => {
            return item.name.includes(e.target.value) || item.desc.includes(e.target.value) || !e.target.value;
        });
        setSearchWord(e.target.value);
        setCurrentList(filterList);
        setDataTotal(filterList.length);
        setPage(1);
    };


    // 数据初始化操作
    useEffect(() => {
        setRadioValue(cityGroup.title);
        setCurrentList(cityGroup.list);
        setDataTotal(cityGroup.list.length);
    }, [cityGroup]);

    return (
        <div className='paddle-pilot-all-group-wrapper'>
            <div className='paddle-pilot-all-group-show-btn' onClick={() => setIsModalVisible(true)}>
                <span className='paddle-pilot-all-group-modal'>{ title }</span>
                <RightOutlined className='paddle-pilot-all-group-icon' />
            </div>

            <Modal
                wrapClassName='paddle-pilot-all-group-modal-wrapper'
                title={title}
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
            >
                <div className='paddle-pilot-all-group-control'>
                    <Radio.Group
                        options={groupOptions}
                        value={radioValue}
                        optionType="button"
                        onChange={handleRadioChange}
                    />
                    <AcademicSearch onSearch={handleSearch} placeholder={`请输入${radioValue === cityGroup.title ? '城市' : '高校'}名称`} />
                </div>

                <div className='paddle-pilot-group-card-wrapper'>
                    {
                        (currentList.slice((page - 1) * 10, page * 10)).map((ele, index) => <div className='paddle-pilot-group-card' key={ele.name + ele.desc + index}>
                            <div className='paddle-pilot-group-card-content'>
                                <img className='paddle-pilot-group-card-avator' src={ele.avator} alt={ele.name} />
                                <div className='paddle-pilot-group-card-name'>{ ele.name }</div>
                                <div className='paddle-pilot-group-card-desc'>{ ele.desc }</div>
                            </div>

                            <div className='paddle-pilot-group-card-hover-content'>
                                <div className='paddle-pilot-group-card-name'>{ ele.name }</div>
                                <div className='paddle-pilot-group-card-desc'>{ ele.desc }</div>
                                <a className='paddle-pilot-group-join-link' href={ele.link} target='_blank' rel='noreferrer'>申请加入</a>
                            </div>
                        </div>)
                    }
                </div>
                <Pagination total={dataToal} onChange={currentPage => {setPage(currentPage)}} hideOnSinglePage={true} />

                {
                    !currentList.length && <div className='all-group-empty'>
                        <div className='all-group-empty-image' />
                        <div className='all-group-empty-word'>抱歉暂无搜索结果</div>
                    </div>
                }
            </Modal>
        </div>
    );
};

export default PilotAllGroup;